export default function WarningSolidIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.98 13.67h10.04a1.333 1.333 0 0 0 1.154-2l-5.02-8.674a1.333 1.333 0 0 0-2.307 0l-5.02 8.673c-.513.887.127 2 1.154 2zM8 9.002a.669.669 0 0 1-.666-.667V7.003c0-.367.3-.667.667-.667.366 0 .666.3.666.667v1.333c0 .367-.3.667-.666.667zm.667 2.666H7.334v-1.333h1.333v1.333z"
        fill="currentColor"
      />
      <mask id="iewpi0o57a" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="1" y="2" width="14" height="12">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.98 13.67h10.04a1.333 1.333 0 0 0 1.154-2l-5.02-8.674a1.333 1.333 0 0 0-2.307 0l-5.02 8.673c-.513.887.127 2 1.154 2zM8 9.002a.669.669 0 0 1-.666-.667V7.003c0-.367.3-.667.667-.667.366 0 .666.3.666.667v1.333c0 .367-.3.667-.666.667zm.667 2.666H7.334v-1.333h1.333v1.333z"
          fill="#fff"
        />
      </mask>
    </svg>
  );
}
